import type { CSSProperties } from 'react';

export const previewHeaderStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 16,
  padding: '12px 16px',
  background: '#f5f5f5',
  borderRadius: 8,
  border: '1px solid #d9d9d9',
};

export const crudActionsStyle: CSSProperties = {
  display: 'flex',
  gap: 8,
  alignItems: 'center',
};

export const editableCellInputStyle: CSSProperties = {
  width: '100%',
};
